export default function(scale) {

    this._options.scale = scale;

    return this;
};
